export enum PropertyType {
  Residential = "residential",
  Commercial = "commercial",
  Apartments = "apartments",
  None = "",
}
